<script setup lang="ts">
import type { PropType } from 'vue';

import { BackendErrorCode } from '~/apiClient';
import { type SaleItemEntity, isAuction } from '~/types/sale.type';

const CANT_PERFORM_ERROR_CODES = [
    BackendErrorCode.CantPerformUnapprovedCompany,
    BackendErrorCode.CantPerformScrapSaleNotScrapyardCompany,
    BackendErrorCode.CantPerformUserCompanyEqSellerCompany,
    BackendErrorCode.CantPerformCompanyUnderReview,
    BackendErrorCode.CantPerformUserWithoutCompany,
    BackendErrorCode.CantPerformCompanyNotYetApprovedForScrap,
    BackendErrorCode.CantPerformCompanyNotApprovedForScrap,
] as const;
type CantPerformErrorCode = (typeof CANT_PERFORM_ERROR_CODES)[number];

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const localePath = useLocalePath();

// COMPUTED
const cantPerformReason = computed(() => (isAuction(sale) ? sale.userMeta?.cantBidReason : sale.userMeta?.cantBuyReason));
const messageKey = computed<TranslationKey>(() => {
    const isCantPerformErrorCode = (code: BackendErrorCode): code is CantPerformErrorCode => CANT_PERFORM_ERROR_CODES.includes(code as any);

    return cantPerformReason.value && isCantPerformErrorCode(cantPerformReason.value)
        ? `sdp.${sale.sellingMethod}.notice.cantPerform.${cantPerformReason.value}`
        : `sdp.${sale.sellingMethod}.notice.cantPerform.generic`;
});
const to = computed(() =>
    cantPerformReason.value === BackendErrorCode.CantPerformScrapSaleNotScrapyardCompany ? localePath({ name: 'faq', hash: '#scrapping' }) : undefined
);
</script>

<template>
    <SdpSalePanelNoticeBase :message="tt(messageKey)" :to="to" icon-class="text-primary" icon-name="lucide:info" />
</template>
